@defer (when _custom()) {
  <app-toolbar size="small">
    <div class="left">
      <app-button tooltipPosition="top" size="small" [selected]="_custom().type === 'today'" (click)="dateTypeSelect('today')" [isDisabled]="!enabled.today" label="Today" [title]="enabled.today ? '' : 'No data today'" />
      <app-button tooltipPosition="top" size="small" [selected]="_custom().type === 'yesterday'" (click)="dateTypeSelect('yesterday')" [isDisabled]="!enabled.yesterday" label="Yesterday" [title]="enabled.yesterday ? '' : 'No data yesterday'" />
      <app-button tooltipPosition="top" size="small" [selected]="_custom().type === 'thisweek'" (click)="dateTypeSelect('thisweek')" [isDisabled]="!enabled.thisweek" label="This	week" [title]="enabled.thisweek ? '' : 'No data this week'" />
      <app-button tooltipPosition="top" size="small" [selected]="_custom().type === 'lastweek'" (click)="dateTypeSelect('lastweek')" [isDisabled]="!enabled.lastweek" label="Last week" [title]="enabled.lastweek ? '' : 'No data last week'" />

      <app-button tooltipPosition="top" size="small" [selected]="_custom().type === 'lastx'" (click)="dateTypeSelect('lastx')" [label]="lastXLabel" [title]="lastXTitleFromUpdate" />

      <app-setpoint-dates-button [asset]="asset" [selected]="_custom().type === 'custom'" size="small" [value]="custom" (onSelect)="datesDialogClosed($event)" [minmax]="minmax()" />
    </div>
    <div class="right">
      <i class="mdi mdi-dots-vertical can-click" (click)="onClickMenu('open')"></i>
      <!--<p-menu #menu [popup]="true" [model]="items" (onClick)="onClickMenu($event)"></p-menu>-->
      <!--
      @if (items) {
        <button class="btn btn-sm" (click)="menu.toggle($event)"><i class="mdi mdi-dots-vertical"></i></button>
      }
    --></div>
  </app-toolbar>

  @if (dialogOpen()) {
    <!--
    
      this.items =
        [
  
          {
            label: 'Y Axis',
            items: [
              {
                label: 'Dynamic', icon: 'mdi mdi-chart-line-variant', command: () => this.setYAxisDynamic(true), badge: this.isDynamicYAxis ? 'set' : '', tooltip: 'Always dynamic based on data, starts from zero'
              },
              {
                label: 'Fixed', icon: 'mdi mdi-chart-line-variant', command: () => this.setYAxisDynamic(false), badge: !this.isDynamicYAxis ? 'set' : '', tooltip: 'Always fixed based on sensor type'
              }
            ]
          },
          {
            label: 'Export',
            items: [
              {
                label: 'Excel', icon: 'mdi mdi-microsoft-excel', command: () => this.export()
              }
            ]
          }
        ];
  
      if (this._asset?.assetType_id === AssetService.ASSET_TYPE_MOISTURE) {
        this.items.push({
          label: 'Questions',
          items: [
            { label: 'The last leak?', icon: 'mdi mdi-database-search-outline', command: () => this.question('last-leak') }
          ]
        });
      }
    }
-->

    <app-dialog (onClose)="dialogOpen.set(null)" [dimensions]="{ width: 500, height: _asset() ? 360 : 260 }" header="Chart Options">
      <section>
        <p>Change the chart Y axis behaviour to fixed if you want it controlled by the type of sensor, or dynamic if you want it controlled by the data.</p>
        <div class="text-right">
          <app-button label="Dynamic" icon="mdi mdi-chart-line-variant" (click)="setYAxisDynamic(true); dialogOpen.set(null)" />
          <app-button label="Fixed" icon="mdi mdi-chart-line-variant" (click)="setYAxisDynamic(false); dialogOpen.set(null)" />
        </div>
      </section>
      @if (_asset()) {
        <section>
          Export the data in the graph as a Microsoft Excel spreadsheet.
          <div class="text-right">
            <app-button label="Export chart data" icon="mdi mdi-microsoft-excel" (click)="export(); dialogOpen.set(null)" />
          </div>
        </section>
      }
    </app-dialog>
  }
} @placeholder (minimum 100ms) {
  <app-toolbar></app-toolbar>
}
